import { Badge } from "@mantine/core";
import { useTranslation } from "react-i18next";

type StatusColor = "gray" | "blue" | "green" | "yellow" | "red" | "orange" | "teal" | "violet";

const STATUS_COLOR_MAP: Record<string, StatusColor> = {
  // Campaign status
  draft: "gray",
  submitted: "blue",
  active: "green",
  done: "teal",
  archived: "gray",
  rejected: "red",
  // Participation: relevant
  not_assessed: "gray",
  yes: "green",
  no: "red",
  // Participation: presented
  not_done: "gray",
  planned: "blue",
  // installed
  in_progress: "orange",
  // Visit status
  planned_visit: "blue",
  postponed: "orange",
  cancelled: "red",
  clarifying: "yellow",
  // Component status
  produktiv: "green",
  in_einfuehrung: "blue",
  abgekuendigt: "red",
  // Note visibility
  segment: "gray",
  cross_segment: "violet",
};

const STATUS_LABEL_KEY_MAP: Record<string, string> = {
  // Campaign status
  draft: "campaignStatus.draft",
  submitted: "campaignStatus.submitted",
  active: "campaignStatus.active",
  done: "campaignStatus.done",
  archived: "campaignStatus.archived",
  rejected: "campaignStatus.rejected",
  // Participation/visit/etc — shared values handled below
  not_assessed: "participationStatus.relevant.not_assessed",
  yes: "common.yes",
  no: "common.no",
  not_done: "participationStatus.presented.not_done",
  planned: "visitStatus.planned",
  in_progress: "participationStatus.installed.in_progress",
  postponed: "visitStatus.postponed",
  cancelled: "visitStatus.cancelled",
  clarifying: "visitStatus.clarifying",
  produktiv: "componentStatus.produktiv",
  in_einfuehrung: "componentStatus.in_einfuehrung",
  abgekuendigt: "componentStatus.abgekündigt",
  segment: "noteVisibility.segment",
  cross_segment: "noteVisibility.cross_segment",
};

interface StatusBadgeProps {
  status: string;
  label?: string;
  variant?: "filled" | "outline" | "light";
}

export function StatusBadge({ status, label, variant = "light" }: StatusBadgeProps) {
  const { t } = useTranslation();
  const color: StatusColor = STATUS_COLOR_MAP[status] ?? "gray";
  const key = STATUS_LABEL_KEY_MAP[status];
  const displayLabel = label ?? (key ? t(key) : status);
  return (
    <Badge color={color} variant={variant}>
      {displayLabel}
    </Badge>
  );
}
